import React, { useEffect } from 'react';
import PlatformPositionCalculator from '../platformPosition.js';

export const Platform = ({ 
    leftIcon, 
    rightIcon, 
    onLeftDragOver, 
    onLeftDragLeave,
    onLeftDrop, 
    onRightDragOver, 
    onRightDragLeave,
    onRightDrop, 
    matchedCategory, 
    isMatching,
    leftSphereRef,
    rightSphereRef,
    highlightedSphere
}) => {
    // Determine which icon to show on the left sphere
    const leftIconName = isMatching && matchedCategory ? matchedCategory.iconName : (leftIcon ? leftIcon.iconName : null);
    const rightIconName = rightIcon ? rightIcon.iconName : null;
    
    // Initialize platform position calculator
    // useEffect(() => {
    //     const calculator = new PlatformPositionCalculator({
    //         iconContainerSelector: '.platform'
    //     });
        
    //     // Store for debugging
    //     window.platformCalculatorForPlatform = calculator;
        
    //     return () => {
    //         console.log('Platform position calculator cleaned up');
    //     };
    // }, []);
    
    // Add touch support via custom events
    useEffect(() => {
        const leftSphere = leftSphereRef.current;
        const rightSphere = rightSphereRef.current;
        
        const handleLeftCustomDrop = (e) => {
            if (e.syntheticEvent) {
                onLeftDrop(e.syntheticEvent);
            }
        };
        
        const handleRightCustomDrop = (e) => {
            if (e.syntheticEvent) {
                onRightDrop(e.syntheticEvent);
            }
        };
        
        if (leftSphere) {
            leftSphere.addEventListener('customDrop', handleLeftCustomDrop);
        }
        if (rightSphere) {
            rightSphere.addEventListener('customDrop', handleRightCustomDrop);
        }
        
        return () => {
            if (leftSphere) {
                leftSphere.removeEventListener('customDrop', handleLeftCustomDrop);
            }
            if (rightSphere) {
                rightSphere.removeEventListener('customDrop', handleRightCustomDrop);
            }
        };
    }, [leftSphereRef, rightSphereRef, onLeftDrop, onRightDrop]);
    
    return (
        <div className="platform">
            <div className={`sphere-container ${isMatching ? 'merging' : ''}`}>
                {/* Left sphere - Drop target for first icon */}
                <div 
                    className={`sphere product-sphere ${isMatching ? 'merge-left' : ''} ${highlightedSphere === 'left' ? 'onboarding-highlight' : ''}`}
                    ref={leftSphereRef}
                    onDragOver={onLeftDragOver}
                    onDragLeave={onLeftDragLeave}
                    onDrop={onLeftDrop}
                >
                    <div 
                        id="left-sphere-icon"
                        className="product-icon"
                        style={{
                            backgroundImage: leftIconName ? `url('./images/SVG/${leftIconName}.svg')` : 'none',
                            // backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            width: '70%',
                            height: '70%'
                        }}
                    >
                    </div>
                </div>
                
                {/* Plus sign - fades out during merge */}
                <div className={`sphere-separator ${isMatching ? 'fade-out' : ''}`}>+</div>
                
                {/* Right sphere - Drop target for second icon / Validation */}
                <div 
                    className={`sphere drop-sphere ${isMatching ? 'merge-right' : ''} ${!leftIcon ? 'disabled' : ''} ${highlightedSphere === 'right' ? 'onboarding-highlight' : ''}`}
                    id="product-sphere" 
                    ref={rightSphereRef}
                    onDragOver={onRightDragOver}
                    onDragLeave={onRightDragLeave}
                    onDrop={onRightDrop}
                >
                    <div 
                        id="right-sphere-icon"
                        className="product-icon"
                        style={{
                            backgroundImage: rightIconName ? `url('./images/SVG/${rightIconName}.svg')` : 'none',
                            // backgroundSize: 'contain',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            width: '70%',
                            height: '70%'
                        }}
                    >
                    </div>
                </div>
            </div>
            
            <div className="platform-base">
                <div className="platform-ring platform-ring-1"></div>
                <div className="platform-ring platform-ring-2"></div>
                <div className="platform-ring platform-ring-3"></div>
            </div>
        </div>
    );
};
